/**
 * @file Multi-steps form
 *
 * @author Todd Li <tli@squiz.net>
 * @date March 2019
 */

(function($){
  'use strict';

  /**
   * use JS to control field visibility based on the value of a select.
   * The value and field id should be stored at data attributes
   * JS is used to add/remove a class (styled with css)
   */
  var preSelectedValue = $('.js-select--conditional select').val();
  if(preSelectedValue) {
    var $conditionalSelect = $('.js-select--conditional');
    var controlValue = $conditionalSelect.data('control-value');
    var controlFieldId = $conditionalSelect.data('control-field-id');

    if($(controlFieldId).length > 0) {
      if(preSelectedValue == controlValue) {
        $(controlFieldId).addClass('visible--conditionally');
        $(controlFieldId + ' input').prop('required', true);
      } else {
        $(controlFieldId).removeClass('visible--conditionally');
        $(controlFieldId + ' input').prop('required', false);
      }
    }
  }

  $('.js-select--conditional select').on('change', function() {
    var selectedValue = $(this).val();
    var controlValue = $(this).parents('.js-select--conditional').data('control-value');
    var controlFieldId = $(this).parents('.js-select--conditional').data('control-field-id');

    if($(controlFieldId).length > 0) {
      if(selectedValue == controlValue) {
        $(controlFieldId).addClass('visible--conditionally');
        $(controlFieldId + ' input').prop('required', true);
      } else {
        $(controlFieldId).removeClass('visible--conditionally');
        $(controlFieldId + ' input').prop('required', false);
      }
    }
  });
  /*
  * use JS to control field visibility based on the value of a select.
  */

  /*
  * use JS to disable/enable field ABN
  */
  if($('.js-abn-input--conditional')) {
    var $abnInput = $('.js-abn-input--conditional input');
    $abnInput.prop('required', true);

    var $ABNCheckbox = $('.js-abn-input--conditional-control input[type="checkbox"]');
    var isChecked = $ABNCheckbox.prop('checked');
    ABNControl(isChecked);

    $ABNCheckbox.on('change', function() {
      isChecked = $(this).prop('checked');
      ABNControl(isChecked);
    });
  }

// CREATED A BACKUP OF THE OLD CODE (WHICH HAD REGION LOGIC IN IT) INSIDE MATRIX FOLDER IN CUTUP
  
$('.js-radio--conditional input[type="radio"]').on('change', function() {

    var selectedValue = $(this).val();
    var controlValue = $(this).parents('.js-radio--conditional').data('control-value');
    var controlFieldId = $(this).parents('.js-radio--conditional').data('control-field-id');
    var $hiddelFields = $(controlFieldId).find('input, textarea');

    if($(controlFieldId).length > 0) {
      if(selectedValue == controlValue) {
        $(controlFieldId).addClass('visible--conditionally');
        if($hiddelFields && $hiddelFields.length > 0) {
          /**
           * When choose 'Your workplace', address input/textarea become required
          */
          $hiddelFields.prop('required', true);
        }
      } else {
        $(controlFieldId).removeClass('visible--conditionally');
        if($hiddelFields && $hiddelFields.length > 0) {
          $hiddelFields.prop('required', false);
        }
      }
    }
  });

  /********** typeahead *********/
  var substringMatcher = function(strs) {
    return function findMatches(q, cb) {
      var matches, substrRegex;

      // an array that will be populated with substring matches
      matches = [];

      // regex used to determine if a string contains the substring `q`
      substrRegex = new RegExp(q, 'i');

      // iterate through the pool of strings and for any string that
      // contains the substring `q`, add it to the `matches` array
      $.each(strs, function(i, str) {
        if (substrRegex.test(str.value)) {
          matches.push(str);
        }
      });

      cb(matches);
    };
  };

  var $subIndustryHiddenBox = $('.js-industry--selected input');
  function getAllIndustries() {
    disableNextBtn();
    var url = 'https://www.safework.nsw.gov.au/safety-starts-here/mental-health-at-work-the-basics/mental-health-@-work/_designs/integrations/squiz/eligibility-form/all-industries';
    var $typeaheadInput = $('.input--typeahead input');
    $typeaheadInput.prop('disabled', true);

    var originalPHText = $typeaheadInput.prop('placeholder');
    var previouslyEnteredIndustry = $typeaheadInput.val();
    $typeaheadInput.val('');
    $typeaheadInput.prop('placeholder', 'Loading industries...');

    $.get(url, function(data) {
      $typeaheadInput.prop('disabled', false);
      $typeaheadInput.prop('placeholder', originalPHText);
      $typeaheadInput.val(previouslyEnteredIndustry);
      var industries = data;
      var industryFlag = false;

      $typeaheadInput.typeahead({
        classNames: {
          input: 'typeahead--input-field',
          hint: 'Typeahead-hint',
          selectable: 'typeahead--option'
        },
        hint: true,
        highlight: true,
        minLength: 0
      }, {
        name: 'result',
        display: 'value',
        limit: 100,
        source: substringMatcher(industries),
        templates: {
            suggestion: function(data) {
              return '<div data-value="'+data.value+'">' + data.value + '</div>';
            }
        },
      });


      var industrySelectedTextBoxInitialText = $('.industry--selected .field__text-box p').text();
      //reset selected industry when navigate from a different step
      if($('.input--typeahead input')) {
        var typeHeadInputSavedValue = $typeaheadInput.val();
        var industryHiddenInputSaveValue = $subIndustryHiddenBox.val();
        if(typeHeadInputSavedValue) {
          setIndustryText(industryHiddenInputSaveValue, typeHeadInputSavedValue, industryHiddenInputSaveValue);
        }
      }

      $typeaheadInput.on('focusout', function(){
        var $industryTextBox = $('.industry--selected .field__text-box');
        if($(this).val().length > 0 && !industryFlag) {
          industryFlag = true;
          var selectedText = $(this).val();

          getIndustry(selectedText);
        } else {
          if($(this).val().length == 0) {
            $industryTextBox.empty();
            var $pInitial = $('<p>', {'text': industrySelectedTextBoxInitialText});
            $industryTextBox.append($pInitial)
            $industryTextBox.removeClass('field__text-box--dark');
            $subIndustryHiddenBox.val('');
          }
        }

      });

      $typeaheadInput.on('focusin', function(){
        if($(this).val().length > 0) {
          industryFlag = false;
        }
      });

      $('.input--typeahead').on('click', '.typeahead--option', function(){
        industryFlag = true;
        var selectedText = $(this).data('value');

        getIndustry(selectedText);
      });

      $('.input--typeahead input').on('keyup', function(event) {
        if (event.keyCode === 13) {
          event.preventDefault();
          industryFlag = true;
          var selectedText = $(this).val();

          getIndustry(selectedText);
        }
      });
      
      enableNextBtn();
    })
    .fail(function(error){
      console.log(error);
      $typeaheadInput.prop('placeholder', 'Failed to load all industries.');
    });
  }

  // Hijack the submit button for the eligibility form.
  $('#form_email_977996').on('submit', function(evt) {

    // Check the current form step.
    // We only want to do some extra work for step #3.
    if ($('#SQ_FORM_977996_PAGE').val() === "3") {

      var capturedJSONData = {"registrationInfo": []},
          funnelbackJSONData = {"regions": []};

      // Collect the user's registration responses data from the dynamic inputs.
      capturedJSONData.registrationInfo = captureCourses();

      // Store the registration responses data in the hidden field. This is used by Handlebars on the Thank You page.
      $('#q978011_q1').val(JSON.stringify(capturedJSONData));

      // Convert the captured data into a flat format that Funnelback can use.
      funnelbackJSONData.regions = convertDataForFunnelback(capturedJSONData.registrationInfo);

      // Store the Funnelback-formatted data in the hidden field. This is used in the Form Submission Actions.
      $('#q978011_q7').val(JSON.stringify(funnelbackJSONData));

      // Continue with the form submission.
      return true;
    }
  });

  //get all industries to initialise typehead
  function getIndustry(industryText) {
    disableNextBtn();
    var $industryTextBox = $('.js-industry--selected .field__text-box');
    if(industryText) {
      industryText = industryText.replace(/\s+/g, " ");
      var url = '//www.safework.nsw.gov.au/safety-starts-here/mental-health-at-work-the-basics/mental-health-@-work/_designs/integrations/squiz/eligibility-form/get-industry?trade='+encodeURI(industryText);

      $.get(url, function(data) {
        try{
          if(data.hasOwnProperty('error')) {
            setIndustryText(data.errorMessage, industryText, '');
            return;
          }

          var tradeTitle = data.industryData.tradeTitle;
          var industry = data.industryData.industry;

          setIndustryText(industry, tradeTitle, industry);
        } catch(error) {
          console.log(error);
        }
        enableNextBtn();
      });
    } else {
      if($industryTextBox.children('.industry--selected').length < 1) {
        $subIndustryHiddenBox.val('');
        var $pInitial = $('<p>', {'text': industrySelectedTextBoxInitialText});
        $industryTextBox.append($pInitial)
        $industryTextBox.removeClass('field__text-box--dark');
        enableNextBtn();
      }
    }
  }
 
  function setIndustryText(spanText, pText, industryHiddenBoxValue) {
    var $industryTextBox = $('.js-industry--selected .field__text-box');
    if(spanText == '' || spanText == null) {
      spanText = 'No matching industries were found.';
    }
    var $span = $('<span>', {'text': spanText});
    var $p = $('<p>', {'class': 'industry--selected', 'text': pText});
    $p.append($span);

    $industryTextBox.empty();
    $industryTextBox.append($p);
    $industryTextBox.addClass('field__text-box--dark');
    $subIndustryHiddenBox.val(industryHiddenBoxValue);
    //update main industry iput value after focus out and applied value;
    let selectedValue = $("p.industry--selected").contents().get(0).nodeValue;
    $('input.typeahead--input-field').val(selectedValue);
  }

 /*
 */
  /**
   * Capture the user's responses to the course inputs.
   *
   * Output Array structure:
   [
    {
      "courseName": "WHS Avice",
      "regions": [{"registerRequest": "NULL","staffCount": "NULL","preferredLocation": "NULL","preferredAddress": "NULL","contactWhenAvailable": "NULL","location": "NULL"}],
      "contactWhenEligible": true
    },
    {
      "courseName": "Manager Training",
      "regions": [],
      "contactWhenEligible": false
    }
   ]
   *
   * @returns Array The course data as objects in an Array
   */

  function captureCourses() {
    var courseDataArray = [],
        userResponded = false,
        regionBlankData = {"registerRequest": "NULL","staffCount": "NULL","preferredLocation": "NULL","preferredAddress": "NULL","contactWhenAvailable": "NULL","preferredCallTime":"NULL","mentalHealthWorkTopic":"NULL","location": "NULL","suburb": "NULL","postcode": "NULL"};

    // Loop over each of the courses.
    $('.js-course-responses').each(function() {

      var courseData = {},
        $ineligibleInput = $(this).find('.js-ineligible-input');

      userResponded = false;

      // Capture the course name.
      courseData.courseName = $(this).attr('data-course-name');

      // Set defaults.
      courseData.contactWhenEligible = false;
      courseData.regions = [];

      // Eligibility check.
      // If not at all eligible for the course then captured any response instead of checking regions.
      if ($ineligibleInput.length !== 0 && $ineligibleInput.is(':checked')) {

        courseData.contactWhenEligible = true;
        userResponded = true;

        // If there are no region-specific responses then add some "blank" data so that Funnelback has an easier time filtering out the respones.
        courseData.regions = [];
        courseData.regions.push(regionBlankData);
      } else {
        // Otherwise, capture the regions data - scoped to this course.
        courseData.regions = captureRegions($(this));

        if (courseData.regions.length > 0) {
          // If the user responded to at least one of the regions then capture this course's data.
          userResponded = true;
        }
      }

      // Only capture this course's data if the user has responded that they want to be notified.
      if (userResponded) {
        // Push the captured data into the Array.
        courseDataArray.push(courseData);
      }
    });

    return courseDataArray;
  }

  /**
   * Capture the user's responses to the course's region inputs.
   *
   * Output Array structure:
   [
    {
      "location": "Hunter - Central Coast",
      "registerRequest": true,
      "staffCount": 250,
      "preferredLocation": "Your workplace",
      "preferredAddress": "12 Gipps Street, Collingwood, VIC 3066",
      "contactWhenAvailable": false
    },
    {
      "location": "Northern - Far North Coast",
      "registerRequest": false,
      "staffCount": 0,
      "preferredLocation": "NULL",
      "preferredAddress": "NULL",
      "contactWhenAvailable": true
    }
   ]
   *
   * @returns Array The region data as Objects in an Array
   */
  function captureRegions($scope) {
    var $region = {},
      $registerRequestInput = {},
      $staffCountInput = {},
      $preferredLocationInput = {},
      $preferredAddressInput = {},
      $contactWhenAvailableInput = {},
      $callDateInput = {},
      $callTimeInput = {},
      $mentalHealthWorkTopicInput = {},
      regionDataArray = [],
      userResponded = false;

    $scope.find('.js-region-responses').each(function() {

      var regionData = {};

      userResponded = false;

      $region = $(this);
      $registerRequestInput = $region.find('.js-register-request');
      $staffCountInput = $region.find('.js-staff-count');
      $preferredLocationInput = $region.find('.js-preferred-location');
      $preferredAddressInput = $region.next('.js-training-location').find('.js-preferred-address');
      $contactWhenAvailableInput = $region.find('.js-contact-available');
      $callDateInput = $region.find('#date-input');
      $callTimeInput = $region.find('#time-input');
      $mentalHealthWorkTopicInput = $region.find('#topics-area');

      // Set defaults.
      regionData.registerRequest = false;
      regionData.staffCount = 0;
      regionData.preferredLocation = "NULL";
      regionData.preferredAddress = "NULL";
      regionData.contactWhenAvailable = false;
      regionData.preferredCallTime = "NULL";
      regionData.mentalHealthWorkTopic = "NULL";

      // Capture the region location.
      regionData.location = $region.attr('data-region-name');
      regionData.postcode = $region.attr('data-postcode');

      // Capture the region suburbs.
      regionData.suburb = $region.attr('data-region-suburbs');

      // Capture the region register request.
      if ($registerRequestInput.length !== 0 && $registerRequestInput.is(':checked')) {
        regionData.registerRequest = true;
        userResponded = true;
      }

      // Capture the staff to be trained.
      if ($staffCountInput.length !== 0) {
        regionData.staffCount = $staffCountInput.val();
      }

      // Capture the training preference.
      if ($preferredLocationInput.length !== 0) {
        regionData.preferredLocation = $preferredLocationInput.find('input[type="radio"]:checked').val();
      }

      // Capture the training location. Removing any new line characters.
      if ($preferredAddressInput.length !== 0) {
        regionData.preferredAddress = $.trim($preferredAddressInput.val().replace(/(\r\n|\n|\r)/gm, ' ')) || "NULL";
      }

      // Capture the preferred time to call.
      if ($callDateInput.length !== 0 && $callTimeInput.length !== 0) {
        regionData.preferredCallTime = $callDateInput.val() + " between " + $callTimeInput.val();
      }

      // Capture the preferred time to call.
      if ($mentalHealthWorkTopicInput.length !== 0) {
        if ($mentalHealthWorkTopicInput.val() !== "") {
          regionData.mentalHealthWorkTopic = $mentalHealthWorkTopicInput.val();
        }
      }

      // Not eligible for this cause, capture if user wants to be contacted.
      if ($contactWhenAvailableInput.length !== 0 && $contactWhenAvailableInput.is(':checked')) {
        regionData.contactWhenAvailable = true;
        userResponded = true;
      }

      // Only capture this region's data if the user has responded that they want to be notified.
      if (userResponded) {
        // Push the captured data into the Array.
        regionDataArray.push(regionData);
      }
    });

    return regionDataArray;
  }

  /**
   * Convert the captured course data into a format that Funnelback can use.
   *
   * Output Array structure:
   [
    {
      "courseName": "WHS Avice",
      "contactWhenEligible": true,
      "location": "Northern - Far North Coast",
      "registerRequest": false,
      "staffCount": 0,
      "preferredLocation": "NULL",
      "preferredAddress": "NULL",
      "contactWhenAvailable": true
    },
    {
      "courseName": "Manager Training",
      "contactWhenEligible": false,
      "location": "Hunter - Central Coast",
      "registerRequest": true,
      "staffCount": 250,
      "preferredLocation": "Your workplace",
      "preferredAddress": "12 Gipps Street, Collingwood, VIC 3066",
      "contactWhenAvailable": false
    }
   ]
   * @param {Array} capturedData The user's responses to the registration questions
   * @returns Array Single-level Array of the data provided in "capturedData"
   */
  function convertDataForFunnelback(capturedData) {

    var funnelbackArray = [],
        regionData = {},
        courseName = "",
        contactWhenEligible = false;

    // Set some default fallback data.
    if (capturedData.length === 0) {

      funnelbackArray = [{
        "courseName": "Ineligible for all training",
        "contactWhenEligible": false,
        "location": "Ineligible for all training",
        "registerRequest": false,
        "staffCount": 0,
        "preferredLocation": "NULL",
        "preferredAddress": "NULL",
        "contactWhenAvailable": false
      }];
    }

    // Loop over the courses
    for (var i = 0, j = capturedData.length; i < j; ++i) {

      // Capture the course details
      courseName = capturedData[i].courseName;
      contactWhenEligible = capturedData[i].contactWhenEligible;

      // Loop over the course's regions
      for (var p = 0, m = capturedData[i].regions.length; p < m; ++p) {

        // Set the region data.
        regionData = capturedData[i].regions[p];
        regionData.courseName = courseName;
        regionData.contactWhenEligible = contactWhenEligible;

        // Clone the Object into the Array.
        funnelbackArray.push($.extend({}, regionData));
      }
    }

    return funnelbackArray;
  }

  function ABNControl(doYouKnowABN) {
    var $abnInput = $('.js-abn-input--conditional input');
    if(doYouKnowABN) {
      $abnInput.prop('disabled', true);
      $abnInput.prop('required', false);
    } else {
      $abnInput.prop('disabled', false);
      $abnInput.prop('required', true);
    }
  }

  function disableNextBtn() {
    $('input[type="submit"][name$="submit"]').prop('disabled', true);
  }

  function enableNextBtn() {
    $('input[type="submit"][name$="submit"]').prop('disabled', false);
  }

  getAllIndustries();

  /*
  * Form step 3 JS control
  * When register with one course, staff no input and location radio button become required with HTML5 required attribute
  * */
 $('.js-cbk--register').on('change', function(){
  var isChecked = $(this).prop('checked');
  var $jsTableRowControl = $(this).parents('.js-table-row');
  if($jsTableRowControl && $jsTableRowControl.length > 0) {
    var $jsControlChildren = $jsTableRowControl.find('.js-required-control');
    if($jsControlChildren && $jsControlChildren.length > 0) {
      if(isChecked) {
        $jsControlChildren.prop('required', true);
      } else {
        $jsControlChildren.prop('required', false);
        $jsControlChildren.each(function() {
          if ($(this).is('input[type="radio"]')) {
            $(this).checked = false;
          } else {
            $(this).prop('value', "");
          }
        });
      }
    }
  }
 });


 /*
  * Form step 3 JS control
  * If the user inputs some details in DPC for the date, time, staff count etc. below script will check register checkbox
  * */
 $('.js-course-responses .js-required-control').on('change', function() {

  var $regionResponse = $(this).closest('.js-region-responses');
  var registerCheck = $regionResponse.find('.js-register-request');
  registerCheck.prop('checked', true);

  if($regionResponse && $regionResponse.length > 0) {
    var $jsControlChildren = $regionResponse.find('.js-required-control');
    if($jsControlChildren && $jsControlChildren.length > 0) {
        $jsControlChildren.prop('required', true);
    }
  }
 });

  //  SWMHAW3-9 NSW API Address
  var $inputAddress = $('.nsw-addresses input'),
    $addressHiddenInput = $('.js-address-checked--hidden input'),
    $postcodeHiddenInput = $('.js-postcode input'),
    $badSelectionTextBox = $('.nsw-addresses .message__text-box'),
    fullAddress = '',
    addressPostcode = '',
    addressSuburb = '',
    fullAddressArray = [];

    // API key is stored in Matrix (assetID#830486) // use this key for testing: "RVhznwqP4t86KJUMiue806fHfkZVrxXr4OD2pI5Y"
    if (API_key !== undefined && API_key !== null && API_key !== "") { 
      var nswPointConfig = {
        "apiKeyPredictive1": API_key, 
        "apiKeyOthers": API_key,
        "selector": $inputAddress,
        "stateTerritory": ["NSW"],
        "maxNumberOfResults": "5",
        "dataset": ["gnaf"],
        onAddressValidated: function(data){
          addressPostcode = data.data.addressDetails.postcode
          addressSuburb = data.data.addressDetails.localityName
          fullAddress = data.data.addressDetails.formattedAddress
          fullAddressArray.push({'address': fullAddress, 'postcode': addressPostcode,'suburb': addressSuburb})
          setHiddenPostcodeAndAddress(fullAddressArray);
        },
        onAddressValidationChanged: function(data){
          if (data) {
            hideBadSelectionMessage()
            $inputAddress.blur()
          } else {
            showBadSelectionMessage();
            $inputAddress.val('');
          }
        },
        onInput: function() {
          hideBadSelectionMessage();
        },
        onBadSelection: function(){
          showBadSelectionMessage();
        },
      };
    }
  
  // NOTE: NSW Address Widget <script> is included in the head section of form-step2.html

    document.addEventListener("DOMContentLoaded", function(event) {
      window.addressWidget = NSWPoint.setupAddressWidget(nswPointConfig);
      let widgetState = {
        addressValidated: addressWidget.addressValidated,
        addressResponse: addressWidget.addressResponse
      }
      let isErrorShown = false;
      if (!widgetState.addressValidated && !isErrorShown) {
        $inputAddress.keypress(function(event) {
          if (event.keyCode == 13) {
              event.preventDefault();
              showBadSelectionMessage();
          }
        });
        isErrorShown = true;
      } else {
        hideBadSelectionMessage();
        isErrorShown = false;
      }
    });
    
  // when navigating from/to step-2, it will save the values and update the display of the input fields
  if($addressHiddenInput.val()) {
    if (!fullAddressArray || fullAddressArray.length === 0) {
      fullAddressArray = getSelectedAddresses();
    }
    fullAddressArray.map(function(item){
      $inputAddress.val(item.address);
    })
  }

  // address postcode text box no longer required on front-end (REFER TO BACKUP FILE IF NEEDED)

  function getSelectedAddresses() {
    var entireAddress = $addressHiddenInput.val();
    var addressesWithPostcodesArray = entireAddress.split(/,(?!\s)/);
    var addressesArray = [];
    addressesWithPostcodesArray.map(function(el) {
      var addressAndPostcode = el.split('#');
      addressesArray.push({'address': addressAndPostcode[0], 'postcode': addressAndPostcode[1], 'suburb': addressAndPostcode[2]});
    });
    return addressesArray;
  }

  // set bad selection message
  function showBadSelectionMessage() {
    $badSelectionTextBox.removeClass('hidden');
  }

  // hide bad selection message
  function hideBadSelectionMessage() {
    $badSelectionTextBox.addClass('hidden');
  }

  // address postcode text box no longer required on front-end

    // Hijack the submit button for step-2.
    $('#form_email_977996').on('submit', function(evt) {
      // Check the current form step.
      if ($('#SQ_FORM_977996_PAGE').val() === "2") {
        if ($postcodeHiddenInput.val() == '') {
          evt.preventDefault();
          showBadSelectionMessage()
        } else {
          hideBadSelectionMessage()
        }
      }
    });

  // set values of hidden input fields
  function setHiddenPostcodeAndAddress(fullAddressArray) {
    var addressArray = [];
    var postcodeArray = [];
  
    if(fullAddressArray.length < 1) {
      $addressHiddenInput.val('');
      $postcodeHiddenInput.val(''); 
      $inputAddress.val('');
    }

    fullAddressArray.map(function(item){
      addressArray = [];
      postcodeArray = [];
      addressArray.push(item.address + '#' + item.postcode + '#' + item.suburb);
      postcodeArray.push(item.postcode);
      $inputAddress.val(item.address);
    });

    if(addressArray.length > 0) {
      $addressHiddenInput.val(addressArray.join(','));
    }

    if(postcodeArray.length > 0) {
      $postcodeHiddenInput.val(postcodeArray.join(','));
    }
  }
  
}(jQuery));